const RESOURCES = {
    resourceTopics: [
    {   
        title: 'side effects',
        description: " some videos I made on the basic skills neccessary to manage this course",
        links: [
            {
                linkText: 'navigating the side effects course site',
                linkSrc: 'https://youtu.be/daLV3K0NYXg',
            },
            {
                linkText: 'resizing an image using gimp',
                linkSrc: 'https://youtu.be/8ukaQw6oPM8',
            },
            {
                linkText: 'making a screenshot in the chrome browser',
                linkSrc: 'https://youtu.be/lkBm5UPu5wg',
            },
            {
                linkText: 'submitting an assignment',
                linkSrc: 'https://youtu.be/HUs52zqxADM',
            },

            {
                linkText: '',
                linkSrc: '',
            },
        ]
    },
        {
        title: 'online tools',
        description: ' web-based tools to help you on your way',
        links: [
            {
                linkText: 'code pen',
                linkSrc: 'https://codepen.io/',
            },
            {
                linkText: 'p5 web editor',
                linkSrc: 'https://editor.p5js.org/',
            },
            {
                linkText: 'cloudinary',
                linkSrc: 'https://cloudinary.com/',
            },
            {
                linkText: 'clippy',
                linkSrc: 'https://bennettfeely.com/clippy/',
            },
            {
                linkText: 'firebase',
                linkSrc: 'https://firebase.google.com/',
            },
            {
                linkText: 'twisted wave online editor',
                linkSrc: 'https://twistedwave.com/online',
            },
            {
                linkText: '',
                linkSrc: '',
            },
            {
                linkText: '',
                linkSrc: '',
            },
            {
                linkText: '',
                linkSrc: '',
            },
            {
                linkText: '',
                linkSrc: '',
            },
        ]
    },


    {
        title: 'downloads',
        description: 'links to download some useful free software',
        links: [
            {
                linkText: 'download visual studio code',
                linkSrc: 'https://code.visualstudio.com/download'
            },
            {
                linkText: 'download audacity',
                linkSrc: 'https://www.audacityteam.org/',
            },
            {
                linkText: 'download gimp',
                linkSrc: 'https://www.gimp.org/downloads/',
            },
            {
                linkText: 'download blender',
                linkSrc: 'https://www.blender.org/',
            },

            {
                linkText: '',
                linkSrc: '',
            },
            {
                linkText: '',
                linkSrc: '',
            },
    ]
    },
    {   
        title: 'top five',
        description: " the sites I can't live without",
        links: [
            {
                linkText: 'github.com',
                linkSrc: 'https://github.com/',
            },
            {
                linkText: 'stack overflow',
                linkSrc: 'https://stackoverflow.com/',
            },
            {
                linkText: 'medium',
                linkSrc: 'https://medium.com/',
            },
            {
                linkText: 'MDN',
                linkSrc: 'https://developer.mozilla.org/en-US/',
            },

            {
                linkText: 'hex color picker',
                linkSrc: 'https://www.google.com/search?q=hex+color+picker&oq=hex+color+picker&aqs=chrome.0.69i59.2266j0j7&sourceid=chrome&ie=UTF-8',
            },

            {
                linkText: '',
                linkSrc: '',
            },
        ]
    },
    {
        title: 'web design resources',
        description: '',
        links: [
            {
                linkText: 'css tricks',
                linkSrc: 'https://css-tricks.com/',
            },
            {
                linkText: 'ux planet',
                linkSrc: 'https://uxplanet.org/',
            },
            {
                linkText: 'learn ui design -- subscribe to free email list',
                linkSrc: 'https://learnui.design/index.html',
            },
            {
                linkText: 'uxcel - web app to learn ux/ui, has a free tier',
                linkSrc: 'https://uxcel.com/',
            },
            {
                linkText: '',
                linkSrc: '',
            },
            {
                linkText: '',
                linkSrc: '',
            },
    ]
    },
   {
    title: 'learn more javascript / html / css',
    description: 'some of my favorite resources for learning javascript',
    links: [
        {
            linkText: 'eloquent javascript -- classic intro book, online for free',
            linkSrc: 'https://eloquentjavascript.net/',
        },
        {
            linkText: 'Daniel Shiffman intro to p5 videos',
            linkSrc: 'https://www.youtube.com/playlist?list=PLRqwX-V7Uu6Zy51Q-x9tMWIv9cueOFTFA',
        },

        {
            linkText: 'free code camp',
            linkSrc: 'https://www.freecodecamp.com',
        },
        {
            linkText: 'educative',
            linkSrc: 'https://www.educative.io/',
        },
        {
            linkText: 'go make things: sign up for daily tips',
            linkSrc: 'https://gomakethings.com/',
        },
        {
            linkText: 'flavio copes -- download free JS ebooks',
            linkSrc: 'https://flaviocopes.com/',
        },
        {
            linkText: 'fun fun function youtube channel',
            linkSrc: 'https://www.youtube.com/channel/UCO1cgjhGzsSYb1rsB4bFe4Q',
        },
        {
            linkText: '',
            linkSrc: 'https://github.com/terkelg/awesome-creative-coding',
        },
]
   },

   {
    title: 'javascript libraries',
    description: 'useful libraries for javascript',
    links: [
        {
            linkText: 'p5 javascript library',
            linkSrc: 'https://p5js.org/',
        },
        {
            linkText: 'p5.play',
            linkSrc: 'https://molleindustria.github.io/p5.play/',
        },
        
        {
            linkText: 'three.js - for 3d/webGL stuff',
            linkSrc: 'https://threejs.org/',
        },
        {
            linkText: 'howler.js -- sound',
            linkSrc: 'https://howlerjs.com/',
        },
        {
            linkText: 'johnny five -- javascript library for sensors',
            linkSrc: 'http://johnny-five.io/',
        },
        {
            linkText: 'mo.js -- javascript browser (not canvas) animation library',
            linkSrc: 'http://mojs.io/',
           
        },
        {
            linkText: 'tone.js - more advanced sounds',
            linkSrc: 'https://tonejs.github.io/',
        },

]
   },

    {
        title: 'raspberry pi',
        description: 'resources for working with the raspberry pi',
        links: [
            {
                linkText: 'raspberry pi FAQ',
                linkSrc: 'https://www.raspberrypi.org/documentation/faqs/',
            },
            {
                linkText: 'getting started with raspberry pi',
                linkSrc: 'https://projects.raspberrypi.org/en/projects/raspberry-pi-getting-started',
            },
            {
                linkText: 'getting started with raspberry pi video',
                linkSrc: 'https://www.youtube.com/watch?v=BpJCAafw2qE',
            },
            {
                linkText: 'download etcher',
                linkSrc: 'https://www.balena.io/etcher/',
            },
            {
                linkText: 'raspberry pi imager',
                linkSrc: 'https://www.raspberrypi.org/software/',
            },
            {
                linkText: '',
                linkSrc: '',
            },
            {
                linkText: 'google coder: A simple way to make web stuff on Raspberry Pi',
                linkSrc: 'http://googlecreativelab.github.io/coder/',
            },
    ]
    },
    {
        title: 'basic electronics',
        description: 'resources for working with the raspberry pi',
        links: [
            {
                linkText: 'soldering irons for beginners',
                linkSrc: 'https://makeradvisor.com/best-soldering-irons-beginners-hobbyists/',
            },
            {
                linkText: 'what to buy to get started in eelectronics',
                linkSrc: 'https://www.youtube.com/watch?v=I0GlWeLxVCQ',
            },
            {
                linkText: 'essential guide to electronics components',
                linkSrc: 'https://www.youtube.com/watch?v=u4md32GMX28',
            },

            {
                linkText: 'a simple guide to electronics components',
                linkSrc: 'https://www.youtube.com/watch?v=6Maq5IyHSuc',
            },
            {
                linkText: 'build a contact microphone',
                linkSrc: 'https://www.instructables.com/Make-a-Contact-Microphone/',
            },

            {
                linkText: 'great scott youtube channel',
                linkSrc: 'https://www.youtube.com/user/greatscottlab',
            },
            {
                linkText: 'eev blog youtube channel',
                linkSrc: 'https://www.youtube.com/c/EevblogDave'
            },
    ]
    },
    {
        title: 'the terminal',
        description: 'using the terminal',
        links: [
            {
                linkText:"linux commands r pi users need to know",
                linkSrc:"https://www.tomshardware.com/reviews/raspberry-pi-command-line-commands,6159.html"
            },
            {
                linkText:"an intro to the terminal",
                linkSrc:"https://ryanstutorials.net/linuxtutorial/"
            },
            {
                linkText: 'intro to linux/unix file system',
                linkSrc: 'https://ryanstutorials.net/linuxtutorial/</li>',
            },
            {
                linkText: 'an interactive vim tutorial',
                linkSrc: 'http://www.openvim.com/',
            },
            {
                linkText: 'Install and set up Windows Terminal',
                linkSrc: 'https://docs.microsoft.com/en-us/windows/terminal/get-started',
            },
            {
                linkText: '',
                linkSrc: '',
            },
    ]  
    },
    

    {
        title: 'git and github',
        description: '',
        links: [
            {
                linkText: 'Daniel Shiffman git and github for poets, series of videos',
                linkSrc: 'https://www.youtube.com/watch?v=BCQHnlnPusY&list=PLRqwX-V7Uu6ZF9C0YMKuns9sLDzK6zoiV',
            },
            {
                linkText: 'the net ninja github tutorials',
                linkSrc: 'https://www.youtube.com/playlist?list=PL4cUxeGkcC9goXbgTDQ0n_4TBzOO0ocPR',
            },
            {
                linkText: 'getting started with git and github (medium article)',
                linkSrc: 'https://towardsdatascience.com/getting-started-with-git-and-github-6fcd0f2d4ac6',
            },
            {
                linkText: 'installing git',
                linkSrc: 'https://git-scm.com/book/en/v2/Getting-Started-Installing-Git',
            },
            {
                linkText: '',
                linkSrc: '',
            },
            {
                linkText: '',
                linkSrc: '',
            },
    ]
    },

    {
        title: 'node and npm',
        description: 'node and npm',
        links: [

            {
                linkText:"Daniel Shiffman : what is Node.js?",
                linkSrc:"https://www.youtube.com/watch?v=RF5_MPSNAtU&t=6s"
            },
            {
                linkText: 'download node',
                linkSrc: 'https://nodejs.org/en/download/',
            },

            {
                linkText: 'Getting started with Node and VS code',
                linkSrc: 'https://code.visualstudio.com/docs/nodejs/nodejs-tutorial',
            },
            {
                linkText: 'why node on raspberry pi?',
                linkSrc: 'https://learn.adafruit.com/node-embedded-development/events?view=all',
            },
            {
                linkText: 'guide to installing node on raspberry pi',
                linkSrc: 'http://thisdavej.com/beginners-guide-to-installing-node-js-on-a-raspberry-pi/',
            },
            {
                linkText: 'the node package manager',
                linkSrc: 'https://www.npmjs.com/',
            },
            {
                linkText: '',
                linkSrc: '',
            },

    ]
    },
    {
    title: 'misc',
    description: 'just some other useful links',
    links: [
        {
            linkText: 'creative coding list @ github',
            linkSrc: 'https://github.com/terkelg/awesome-creative-coding',
        },
        {
            linkText: 'ossu: path to a free self-taught CS education',
            linkSrc: 'https://github.com/ossu/computer-science',
        },
        {
            linkText: 'freesound.org',
            linkSrc: 'https://freesound.org/',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },
        {
            linkText: '',
            linkSrc: '',
        },

    ]
    }
]
}

export default RESOURCES